import type { FilterMainComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import { BudgetRange } from '@/app/common/filters/types/range/BudgetRange.tsx';
import { useScaledRangeFilter } from '@/app/common/filters/types/range/useScaledRangeFilter.ts';

export const BudgetRangeFilter = ({ filter, columns, isLoading, handleFilterChanged }: FilterMainComponentProps) => {
  const scaled = useScaledRangeFilter({ filter, handleFilterChanged });

  return (
    <BudgetRange
      filter={scaled.filter}
      columns={columns}
      isLoading={isLoading}
      handleFilterChanged={scaled.handleFilterChanged}
      roundTo={scaled.roundTo}
    />
  );
};
